module.exports = __webpack_public_path__ + "img/bottom_line_1.67962d35.png";